/**
 * FK label resolvers — entity-target overrides for {@link useEntityFkLookups}.
 *
 * Some FK targets (e.g. UserData) cannot be resolved via the client repository
 * (global collection, permission, or volume). Register a batch resolver here
 * so every consumer gets the correct path without module-specific code.
 */
import { USER_DATA } from '@syscolect/domain';
import { userDirectoryService } from '../services/userDirectoryService.js';
const resolvers = new Map();
export function registerFkLabelResolver(targetEntity, resolver) {
    resolvers.set(targetEntity, resolver);
}
export function getFkLabelResolver(targetEntity) {
    return resolvers.get(targetEntity);
}
registerFkLabelResolver(USER_DATA, (ids) => userDirectoryService.getUserNames(ids));
//# sourceMappingURL=fkLabelResolvers.js.map